/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {ApiIpRange} from '../models/ApiIpRange';
import type {Error} from '../models/Error';
import type {IpRangeSection} from '../models/IpRangeSection';

export interface GetIpRanges$Request {
    accountId: number;
}

export interface GetIpRanges$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getIpRangesRequest = createAction<PayloadData<void, GetIpRanges$Request>>('IP_CONTROLLER__GET_IP_RANGES__REQUEST');
export const getIpRangesSuccess = createAction<PayloadData<IpRangeSection, GetIpRanges$Request>>('IP_CONTROLLER__GET_IP_RANGES__SUCCESS');
export const getIpRangesFailure = createAction<PayloadData<Error, GetIpRanges$Request, true>>('IP_CONTROLLER__GET_IP_RANGES__FAILURE');

export const getIpRangesActions = [
    getIpRangesRequest,
    getIpRangesSuccess,
    getIpRangesFailure
] as const;

/**
 * Get Ip Range by Account id
 * @param {number} meta.accountId Account id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getIpRanges = (meta: GetIpRanges$Request, config?: GetIpRanges$Config) => {
    return {
        CALL_API: {
            types: getIpRangesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/api-v2/${meta.accountId}/settings/ip-ranges`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveIpRanges$Request {
    accountId: number;
    apiIpRange: Array<ApiIpRange>;
}

export interface SaveIpRanges$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveIpRangesRequest = createAction<PayloadData<void, SaveIpRanges$Request>>('IP_CONTROLLER__SAVE_IP_RANGES__REQUEST');
export const saveIpRangesSuccess = createAction<PayloadData<void, SaveIpRanges$Request>>('IP_CONTROLLER__SAVE_IP_RANGES__SUCCESS');
export const saveIpRangesFailure = createAction<PayloadData<Error, SaveIpRanges$Request, true>>('IP_CONTROLLER__SAVE_IP_RANGES__FAILURE');

export const saveIpRangesActions = [
    saveIpRangesRequest,
    saveIpRangesSuccess,
    saveIpRangesFailure
] as const;

/**
 * Save Ip Range by Account id
 * @param {number} meta.accountId Account id
 * @param {Array<ApiIpRange>} meta.apiIpRange
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveIpRanges = (meta: SaveIpRanges$Request, config?: SaveIpRanges$Config) => {
    return {
        CALL_API: {
            types: saveIpRangesActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/api-v2/${meta.accountId}/settings/ip-ranges`,
            TRANSPORT_REQUEST_BODY: meta.apiIpRange,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

